import { render, staticRenderFns } from "./SiteForums.vue?vue&type=template&id=2b9a8a61&"
import script from "./SiteForums.vue?vue&type=script&lang=js&"
export * from "./SiteForums.vue?vue&type=script&lang=js&"
import style0 from "./SiteForums.vue?vue&type=style&index=0&id=2b9a8a61&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports